// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"2242479e","746":"a7b2c39c"}[chunkId] + ".chunk.css";
};